<template>
    <button @click.stop.prevent="toggle"
            class="p-1 hover:scale-110 transition-transform"
            title="Toggle favorite">
        <span class="select-none" 
              :class="starred ? 'text-blue-400' : 'text-gray-300 hover:text-blue-300'"
              style="font-size: 1.35em;">{{ starred ? '★' : '☆' }}</span>
    </button>
</template>

<script>
import axios from 'axios';

export default {
    name: 'FavStar',
    props: {
        tileId: { required: true },
        initialStarred: { type: Boolean, default: false },
        baseUrl: { type: String, required: true },
        authToken: { type: String, required: true },
    },
    data() {
        return {
            starred: this.initialStarred,
        };
    },
    watch: {
        initialStarred(val) {
            this.starred = val;
        },
    },
    methods: {
        toggle() {
            this.starred = !this.starred;

            // Update Vuex so other views stay in sync
            if (this.starred) {
                this.$store.commit('ADD_FAVORITE_TILE', { tile_id: this.tileId });
            } else {
                this.$store.commit('REMOVE_FAVORITE_TILE', this.tileId);
            }

            const bodyFormData = new FormData();
            bodyFormData.append('tile_id', this.tileId);

            const endpoint = this.starred ? 'addfavoritetile' : 'removefavoritetile';

            axios({
                method: "post",
                url: this.baseUrl + "/apiv3/" + endpoint + ".json",
                data: bodyFormData,
                headers: {
                    "auth": this.authToken,
                    "Content-Type": "multipart/form-data"
                }
            }).catch(error => {
                console.error('Favorite toggle failed:', error);
            });
        },
    },
};
</script>
